/**
 * Shared form field styles for all country eligibility assessment steps.
 * Keeps input/select boxes consistent: white background, clear borders,
 * placeholder hides on focus, and caret color matches "Predictive Funding Intelligence" blue (#60A5FA).
 */

// For <Input> and <SelectTrigger>: white box, focus placeholder hidden, blue caret
export const INPUT_BOX_CLASS =
  "!bg-white !border-slate-300 border-2 text-slate-800 placeholder:!text-slate-400 shadow-sm focus:!border-[#0f1d3a] focus:!ring-0 focus:placeholder:opacity-0 caret-[#60A5FA]";

export const INPUT_BOX_STYLE = {
  color: "#1e293b",
  borderColor: "#cbd5e1",
  borderWidth: "2px",
  caretColor: "#60A5FA",
};

/**
 * Dim unselected siblings once a choice is made (same feel as GrantHistoryStep checklists).
 * Selected row stays sharp so the radio remains clear. 0.85 keeps 14px option labels
 * above 4.5:1 on paper (0.65 dropped them to roughly 3:1); no blur, the sheet never blurs.
 */
export const ELIGIBILITY_PEER_DIM_STYLE = {
  opacity: 0.85,
};

/** Mutually exclusive card row: dim when another option in the group is already selected. */
export function eligibilityChoiceDimStyle(isSelected, groupAnswered) {
  return groupAnswered && !isSelected ? ELIGIBILITY_PEER_DIM_STYLE : undefined;
}

/**
 * Boolean pair row: `selectedWhen` is which value (`'true'` or `'false'`) selects THIS row.
 */
export function eligibilityBoolRowDim(value, selectedWhen) {
  const settled = value === true || value === false;
  const isThisRow =
    selectedWhen === "true" ? value === true : value === false;
  return settled && !isThisRow ? ELIGIBILITY_PEER_DIM_STYLE : undefined;
}
